import { Answer, QuestionProps } from 'src/types/questionnaire.types';
import { useMemo, useState } from 'react';
import { InputNumber } from 'antd';

export const InputQuestion = ({
  question,
  handleSelectAnswer,
  stepNumber,
  selectedOption = [],
}: QuestionProps) => {
  const choice = useMemo(
    () =>
      (selectedOption as Answer[])[0]?.title
        ? Number((selectedOption as Answer[])[0]?.title)
        : null,
    [selectedOption]
  );

  const onChange = (value: number | null) => {
    handleSelectAnswer(
      {
        ...question,
        choices: value
          ? [{ id: value.toString(), title: value.toString() }]
          : [{ id: '0', title: '0' }],
      },
      stepNumber
    );
  };

  return (
    <InputNumber
      size='large'
      placeholder='E.g. 18'
      min={0}
      max={99}
      value={choice}
      autoFocus
      onChange={onChange}
    />
  );
};
